import React, { Fragment, useState } from 'react';
import {
  Box,
  makeStyles,
  Typography,
  Fade,
  Grid,
  useMediaQuery,
} from '@material-ui/core';
import { string, bool, shape, arrayOf } from 'prop-types';
import ContactForm from '../../../sections/contact/form';
import ApplyForm from '../../../sections/apply/form';
import FeedbackMessage from '../../../shared/sections/form-section/FeedbackMessage';
import styles from './index.styles';
import { useTheme } from '@material-ui/styles';
import Container from '../../Container';
import { Link } from 'gatsby';

const useStyles = makeStyles(styles);

const FormSection = ({
  title,
  descriptions,
  successMessage,
  isContactForm,
}) => {
  const [formIsSent, setFormIsSent] = useState(false);
  const classes = useStyles({
    formIsSent,
    isContactForm,
  });
  const theme = useTheme();
  const smallScreen = useMediaQuery(
    theme.breakpoints.down('xs')
  );

  return (
    <Grid
      container
      justify="center"
      alignItems="center"
      className={classes.container}
    >
      <Container>
        <Grid
          container
          item
          direction="column"
          className={classes.formSection}
          justify="center"
        >
          {!formIsSent && (
            <Grid
              container
              item
              className={classes.textContainer}
            >
              <Typography
                variant="h2"
                className={classes.title}
              >
                {title}
              </Typography>
              <Typography
                variant="body1"
                className={classes.description}
              >
                {descriptions.map(
                  ({ description, isLink, linkTo }) => {
                    return (
                      <Fragment key={description}>
                        {isLink ? (
                          <Link
                            to={linkTo}
                            className={
                              classes.descriptionLink
                            }
                          >
                            {description}
                          </Link>
                        ) : !isContactForm &&
                          !smallScreen ? (
                          description.replace('\n', '')
                        ) : (
                          description
                        )}
                      </Fragment>
                    );
                  }
                )}
              </Typography>
            </Grid>
          )}
          {isContactForm ? (
            <ContactForm
              setFormIsSent={setFormIsSent}
              formIsSent={formIsSent}
            />
          ) : (
            <ApplyForm
              setFormIsSent={setFormIsSent}
              formIsSent={formIsSent}
            />
          )}
          <Fade
            in={formIsSent}
            timeout={{ enter: 300, exit: 0 }}
            mountOnEnter
            unmountOnExit
          >
            <FeedbackMessage
              title={successMessage.title}
              description={successMessage.message}
              buttonText={successMessage.buttonText}
              action={() => setFormIsSent(false)}
              showButton={!!isContactForm}
            />
          </Fade>
        </Grid>
      </Container>
      <Box
        className={`${classes.basePattern} ${classes.topRightPattern}`}
      />
      <Box
        className={`${classes.basePattern} ${classes.bottomLeftPattern}`}
      />
    </Grid>
  );
};

FormSection.propTypes = {
  title: string,
  descriptions: arrayOf(
    shape({
      description: string,
      isLink: bool,
      linkTo: string,
    })
  ),
  successMessage: shape({
    title: string,
    message: string,
    buttonText: string,
  }),
  isContactForm: bool,
};

export default FormSection;
